<!-- https://8es9hr.axshare.com/#g=1&p=%E8%87%A8%E6%AB%83%E4%BD%9C%E6%A5%AD%E9%A6%96%E9%A0%81_%E9%81%B8%E5%AE%9A%E7%A4%BE%E5%93%A1_default -->
<!-- 臨櫃作業首頁_選定社員_default -->
<template>
	<div class="row" v-if="$route.meta.listKeepAlive">
		<div class="col-8">
			<strong v-if="memberChoose.member"
				>{{ memberChoose.member.account }}
				{{ memberChoose.member.name }}</strong
			>
			<!-- 只有社員可以搜尋其他社員 -->
			<el-button
				type="danger"
				class="ml10 mb10"
				plain
				@click="goSearch('cabinet_search')"
				>搜尋其他社員</el-button
			>
			<br />
			<!-- 基本選擇項目 -->
			<div class="row row-set">
				<div class="col-4">
					<div class="col-block">
						<div class="block-content">
							<el-button
								type="primary"
								plain
								v-for="(button, index) in statusButton[
									memberStatus
								]"
								:key="index"
								@click="go(button)"
								>{{ button.label }}</el-button
							>
						</div>
					</div>
				</div>
				<!-- 社員類型-->
				<div class="col-8">
					<div class="col-block" style="width: 100%; height: 100%">
						<div class="block-content">
							<h3>
								<strong>社員類型</strong>
							</h3>
							<p v-if="memberChoose.member.typeKey === 1">
								自然人
							</p>
							<p v-if="memberChoose.member.typeKey === 2">法人</p>
							<h3>
								<strong>統一編號/身分證件號</strong>
							</h3>
							<p>{{ memberChoose.member.idNumber }}</p>
							<h3>
								<strong>聯絡地址</strong>
							</h3>
							<p>
								{{
									memberChoose.member.mailingAddress | address
								}}
							</p>
							<h3>
								<strong>聯絡電話</strong>
							</h3>
							<p>{{ memberChoose.member.tel }}</p>
							<h3>
								<strong>EMAIL</strong>
							</h3>
							<p>{{ memberChoose.member.email }}</p>
							<h3>
								<strong>股金/儲金結餘</strong>
							</h3>
							<p v-if="memberChoose.member.isFormal == 1">
								{{ memberChoose.stockBalance }}
							</p>
							<p v-if="memberChoose.member.isFormal == 0">
								{{ memberChoose.savingBalance }}
							</p>
							<h3>
								<strong>備轉金結餘</strong>
							</h3>
							<p>{{ memberChoose.transferBalance }}</p>
						</div>
					</div>
				</div>
			</div>
			<br />
			<!-- 所屬群組代號 有可能做元件 -->
			<div class="row">
				<div class="col-6">
					<div class="col-block">
						<div class="block-content">
							<!-- 近期資訊 -->
							<h3 class="mb10">
								<strong>近期資訊</strong>
							</h3>
							<el-card class="box-card">
								<div v-if="lastStock">
									<span class="mr10">前次存股金</span>
									<span>{{
										dateChange(lastStock.voucherDate)
									}}</span>
									<span class="ml-3"
										>{{
											$addcomma(lastStock.amountChange)
										}}元</span
									>
								</div>
							</el-card>
							<el-card
								class="box-card"
								v-if="
									memberChoose.memberIou &&
									memberChoose.memberIou.length > 0
								"
							>
								<h3>
									<strong>未償還借據</strong>
								</h3>
								<div
									class="mt10"
									v-for="item in memberChoose.memberIou"
								>
									<el-button
										type="primary"
										plain
										size="small"
										class="flo_r"
										style="width: 100px"
										@click="openDialog(item, true)"
										>還款試算</el-button
									>
									<h3 v-if="item.iou.iouNumber">
										{{ item.iou.iouNumber }}
									</h3>
									<p>
										剩餘本金 :
										{{
											$addcomma(
												item.iouCalculate
													.loanPriceBeforePay
											)
										}}
									</p>
									<p>
										欠繳利息 :
										{{
											$addcomma(
												item.iouCalculate
													.payBackInterest
											)
										}}
									</p>
									<p>
										欠繳違約金 :
										{{
											$addcomma(
												item.iouCalculate
													.payBackBreakPrice
											)
										}}
									</p>
									<p>
										期還金額 :
										{{
											$addcomma(
												item.iouCalculate
													.stageLoanPay
											)
										}}
									</p>
									<p>
										年利率 :
										{{
											item.iouCalculate.normalAnnualRate !=
											null
												? item.iouCalculate
														.normalAnnualRate + "%"
												: "-"
										}}
									</p>
									<p>
										借款起始日 :
										{{ formatLoanStartDate(item.iou.iouDateStart) }}
									</p>
								</div>
							</el-card>
							<el-card
								class="box-card"
								v-if="
									memberChoose.memberPlan &&
									memberChoose.memberPlan.length > 0
								"
							>
								<h3>
									<strong>已參與安基專案</strong>
								</h3>
								<p v-for="item in memberChoose.memberPlan">
									{{ item.insPlanMainName }}
									<el-button
										type="danger"
										plain
										size="small"
										class="flo_r"
										style="width: 100px"
										@click="toInsPlanMember(item)"
										>申請理賠</el-button
									>
									<br />
									<span
										>參與子方案 :
										{{ item.insPlanSubName }}</span
									>
								</p>
							</el-card>
						</div>
					</div>
				</div>
				<div class="col-6">
					<div class="col-block">
						<div class="block-content">
							<!-- 群組編號 -->
							<el-card class="box-card">
								<h3>
									所屬群組代號：
									<span >{{
										memberChoose.memberGroupInfo.code
									}}</span>
								</h3>
							</el-card>
							<!-- 群組成員 -->
							<el-card
								class="box-card"
								v-for="(memberRow, index) in memberGroup"
								:key="index"
							>
								<h3>
									<strong
										>成員{{ index + 1 }}:{{
											memberRow.groupMember.account
										}}
										{{ memberRow.groupMember.name }}</strong
									>
								</h3>
								<div class="mt10">
									<el-button
										type="primary"
										plain
										size="small"
										style="width: 120px"
										@click="
											chooseMember(
												memberRow.groupMember.id
											)
										"
										>切換至此社員</el-button
									>
								</div>
								<div
									class="mt10"
									v-for="(item, iouIndex) in memberRow.iou"
									:key="iouIndex"
								>
									<h3 v-if="item.iouNumber">
										{{ item.iouNumber }}
									</h3>
									<h3 v-else></h3>
									<el-button
										type="primary"
										plain
										size="small"
										class="flo_r"
										style="width: 100px"
										@click="
											openDialog(item.iouNumber, false)
										"
										>還款試算</el-button
									>
								</div>
							</el-card>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-4 pl-2" style="width: 100%">
			<!-- 社員記事 -->
			<div class="col-block mt-5" style="width: 100%">
				<div class="block-content">
					<h3 class="mb10">
						<strong>社員記事</strong>
					</h3>
					<el-card
						class="box-card"
						:memberNote="memberNote"
						v-for="item in memberNote"
						:key="item.id"
						v-show="item.homepage"
					>
						<span>{{ $transferDate(item.updateTime) }}</span>
						<p>{{ item.note }}</p>
					</el-card>
				</div>
			</div>
		</div>
		<el-dialog
			title
			:visible.sync="dialogListForm"
			:modal-append-to-body="false"
			:append-to-body="true"
			width="700px"
		>
			<div slot="title" v-if="iouCalculate">
				{{ iouCalculate.iou.iouNumber + " " + currentTime }} 試算結果
				<div class="date">
					<input
						type="text"
						class="min_go_date baseDate"
						placeholder="選擇日期"
					/>
					<span class="el-input__prefix">
						<i style="margin-top: 12px" class="el-icon-date"></i>
					</span>
				</div>
				<el-button class="ml10" type="primary" @click="changeData" plain
					>變更日期</el-button
				>
			</div>
			<div>
				<p class="fs15">
					每期應還金額:
					{{ $addcomma(iouCalculate.iouCalculate.stageLoanPay) }}
				</p>
				<p class="fs15">
					上次償還日期:
					{{ $transferDate(iouCalculate.iouCalculate.lastPayDate) }}
				</p>
				<p class="fs15">
					剩餘本金:
					{{
						$addcomma(iouCalculate.iouCalculate.loanPriceBeforePay)
					}}
				</p>
				<p class="fs15">
					當下利率: {{ iouCalculate.iouCalculate.normalAnnualRate }}
				</p>
				<p class="fs15">
					還款寬限日: {{ iouCalculate.iouCalculate.securedGraceDay }}
				</p>
				<p class="fs15">
					違約金利率: {{ iouCalculate.iouCalculate.loanPenalty }}
				</p>
				<p class="fs15">
					前欠利息:
					{{ iouCalculate.iouCalculate.interestNotPayBefore }}
				</p>
				<p class="fs15">
					前欠違約金:
					{{ iouCalculate.iouCalculate.breakNotPayBefore }}
				</p>
				<p class="fs15">
					協議前欠金額:
					{{ $addcomma(agrBackpayAmount) }}
				</p>
				<p class="fs15">
					應還利息減免金額:
					{{ iouCalculate.iouCalculate.interestAmountReduction }}
				</p>
				<p class="fs15">
					應還違約金減免金額:
					{{ iouCalculate.iouCalculate.breakAmountReduction }}
				</p>

				<p class="fs15">
					應繳本金:
					{{ $addcomma(iouCalculate.iouCalculate.payBackLoanPrice) }}
				</p>
				<p class="fs15">
					應繳利息(含前欠):
					{{ $addcomma(iouCalculate.iouCalculate.payBackInterest) }}
				</p>
				<p class="fs15">
					應繳違約金(含前欠):
					{{ $addcomma(iouCalculate.iouCalculate.payBackBreakPrice) }}
				</p>
			</div>
			<div
				v-for="(detail, id) in iouCalculate.iouCalculate.detail"
				:key="id"
			>
				<table class="table table-bordered mb-0">
					<thead class="grey lighten-4">
						<tr>
							<th colspan="3">
								<h3>
									<strong>第{{ detail.stage }}期</strong>
								</h3>
							</th>
						</tr>
					</thead>
					<thead class="grey lighten-4">
						<tr>
							<th>應還項目</th>
							<th>應還金額</th>
							<th>金額細節</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>應還本金</td>
							<td>{{ $addcomma(detail.stageLoanPay) }}</td>
							<td></td>
						</tr>
						<tr>
							<td>應還利息</td>
							<td>{{ $addcomma(detail.stageInterest) }}</td>
							<td style="overflow-x: scroll">
								<p style="white-space: nowrap; width: 150px">
									{{
										renderCauculateString(
											detail.interestRateDetail,
											detail.paymentType
										)
									}}
								</p>
							</td>
						</tr>
						<tr>
							<td>應還違約金</td>
							<td>{{ $addcomma(detail.breakPrice) }}</td>
							<td style="overflow-x: scroll">
								<p style="white-space: nowrap; width: 150px">
									{{
										renderCauculateString(
											detail.breakPriceDetail,
											1,
											true
										)
									}}
								</p>
							</td>
						</tr>
						<tr>
							<td>總計</td>
							<td>{{ $addcomma(detail.stagePayBack) }}</td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
			<div slot="footer" class="dialog-footer"></div>
		</el-dialog>
	</div>
	<router-view v-else></router-view>
</template>
<script>
import { API } from "@/assets/config";
import moment from "moment";

export default {
	name: "cabinet_edit",
	data() {
		return {
			id: this.$route.params.id,
			memberChoose: {
				member: { typeKey: 0 },
				mrmberIou: [],
				memberPlan: [],
				lastStock: {},
				memberGroupInfo: {
					code: "",
				},
			},
			lastStock: {},
			memberGroup: [],
			recordToEdit: [
				{
					lastStock: {
						recordDate: "",
						record: {},
					},
					memberGroup: {
						code: "",
					},
				},
			],
			memberNote: [],
			memberStatus: 0,
			currentTime: "",
			tableData: [
				{
					title: "應還本金",
					price: 0,
				},
				{
					title: "應還利息",
					price: 0,
				},
				{
					title: "應還違約金",
					price: 0,
				},
				{
					title: "總計",
					price: 0,
				},
			],
			statusButton: [
				[
					// 社員
					{ label: "現金收款作業", name: "cabinet_cash" },
					{ label: "社員基本資料", name: "member_edit" },
					{ label: "備轉金存摺補摺",name: "cabinet_transfer_passbook" },
					{ label: "股金存摺補摺", name: "cabinet_stock_passbook" },
					{ label: "委託轉帳", name: "entrusted_transfer" },
					{ label: "貸款申請", name: "loan_application" },
					{ label: "加保互助基金", name: "agent" },
					{ label: "社員轉帳備忘錄", name: "cabinet_transfer"},
				],
				[
					// 準社員
					{ label: "現金收款作業", name: "cabinet_cash" },
					{ label: "社員基本資料", name: "member_edit" },
					{ label: "儲金存摺補摺", name: "cabinet_saving_passbook" },
					{ label: "社員轉帳備忘錄", name: "cabinet_transfer"},
				],
				[
					// 退社社員
					{ label: "社員基本資料", name: "" },
					{ label: "備轉金金存摺補摺", name: "" },
					{ label: "股金存摺補摺", name: "" },
					{ label: "退社作業", name: "" },
					{ label: "社員轉帳備忘錄", name: "cabinet_transfer" },
				],
			],
			iouCalculate: { iou: {}, iouCalculate: {} },
			agrBackpayAmount: undefined,
			// 社員記事
			listData: [],
			iouObj: {},
			loanModal: false,
			dialogListForm: false,
		};
	},
	created() {
		this.getData();
	},
	beforeRouteUpdate(to, from, next) {
        if (to.name === this.$options.name || to.params.id !== from.params.id) {
            this.id = to.params.id; // 更新 ID
            this.getData(); // 重新抓資料
        }
        next();
    },
	filters: {
		address(item) {
			if (item) {
				return item.replace(/\s+/g, ""); //移除地址的空白
			}
		},
		filterData(date) {
			if (date) {
				let Y = date.substr(0, 4) - 1911;
				let M = date.substr(5, 2);
				let D = date.substr(8, 2);
				let A = `${Y}-${M}-${D}`;
				return A;
			} else {
				return "";
			}
		},
	},
	methods: {
		renderCauculateString(
			interestRateDetail,
			paymentType,
			isBreakPrice = false
		) {
			let result = "";

			if (interestRateDetail == null) return result;

			interestRateDetail.forEach((rateDetail) => {
				let date = {
					beginDate: this.$transferDate(rateDetail.beginDate),
					endDate: this.$transferDate(rateDetail.endDate),
				};
				let dateDiff = rateDetail.dateDiff;
				let interestRate = rateDetail.interestRate;
				let interest =
					paymentType == 2
						? rateDetail.interestMonthly
						: rateDetail.interestDaily;
				let loanPrice = rateDetail.loanPrice;

				result += `${date["beginDate"]} ~ ${
					date["endDate"]
				} ${dateDiff}天 ${
					isBreakPrice ? "利息" : "本金"
				}${this.$addcomma(
					loanPrice || "0"
				)}元 年利率 ${interestRate}% 共 ${this.$addcomma(
					interest || "0"
				)} 元 `;
			});

			return result;
		},
		toInsPlanMember(planMember) {
			this.$router.push({
				path: `/home/coop/anji/agent/${planMember.insPlanMainCode}/agent_claim/new`
			});
		},
		getData() {
			const url = API.counterWork + `?id=${this.id}&action=getMemberData`;
			const thenCB = (json) => {
				this.recordToEdit = json.resultData;
				this.memberChoose = this.recordToEdit.memberInfo;
				this.memberNote = this.recordToEdit.memberInfo.memberNote;
				this.lastStock = this.recordToEdit.memberInfo.lastStock;
				this.memberGroup = this.recordToEdit.memberGroup.filter(
					(member) =>
						member.groupMember.id != this.memberChoose.member.id
				);

				// 拆分社員、準社員、退社社員(功能不全)
				//if (this.recordToEdit.memberInfo.member.isExit == 1) {
				//	this.memberStatus = 2; // 退社社員
				//} else 
				if (this.recordToEdit.memberInfo.member.isFormal == 0) {
					this.memberStatus = 1; // 準社員
				} else {
					this.memberStatus = 0; // 社員
				}
			};

			this.mAxiosGet(url, thenCB);
		},
		go(item) {
			// 0430 改回重新導頁 並帶參數顯示返回社員首頁按鈕
			if (item.name === 'member_edit' && this.memberChoose.member.isFormal === 0) {
				item.name = 'quasi_member_info';
			}
			this.$router.push({
				name: item.name,
				params: {
					id: this.id,
					detail: item.DetailArr ? this.recordToEdit[0] : "",
					back: true
				},
			});
		},
		goSearch(name) {
			this.$router.push({
				name: name,
			});
		},
		chooseMember(id) {
			this.$router.push({
				name: "cabinet_edit",
				params: {
					id: id,
				},
			});
		},
		calcInsTotalPayment(insArray = []) {
			let total = 0;
			insArray.forEach((ins) => {
				total += ins.payAmount;
			});
			return total;
		},
		calcRepayment(iouNumber, currentTime = null) {
			const form = new FormData();
			currentTime =
				currentTime != null
					? currentTime
					: moment(new Date()).format("YYYY/MM/DD");

			const thenCB = (json) => {
				this.iouCalculate.iou.iouNumber = iouNumber;
				this.iouCalculate.iouCalculate = json.resultData;
			};

			form.append("baseDate", currentTime);
			form.append("iouNumber", iouNumber);

			this.mAxiosPost(
				API.coopLoanIou + "?action=getCalByDate",
				form,
				thenCB
			);
		},
		handleTableData(resultData) {
			this.tableData[0].price = resultData.payBackLoanPrice;
			this.tableData[1].price = resultData.payBackInterest;
			this.tableData[2].price = resultData.payBackBreakPrice;
			this.tableData[3].price =
				resultData.payBackLoanPrice +
				resultData.payBackInterest +
				resultData.payBackBreakPrice;
		},
		dateChange(date) {
			if (date == undefined) {
				return "";
			} else {
				let Y = date.substr(0, 4) - 1911;
				let M = date.substr(5, 2);
				let D = date.substr(8, 2);
				let A = `${Y}-${M}-${D}`;
				return A;
			}
		},
		// 回傳的 iouDateStart 為 JSON 字串 轉換為民國年格式
		formatLoanStartDate(val) {
			if (!val) return "-";
			const str = typeof val === "string" ? val.slice(0, 10) : "";
			return str ? this.dateChange(str) : "-";
		},
		// 協議前欠金額
		fetchAgrBackpay(iouId, baseDate) {
			if (!iouId || !baseDate) {
				this.agrBackpayAmount = undefined;
				return;
			}
			const agrUrl =
				API.coopLoanIou +
				`?action=getAgrBackpay&coopLoanIouId=${iouId}&baseDate=${baseDate}`;
			this.mAxiosGet(agrUrl, (json) => {
				let sumAmount = 0;
				const data = (json.resultData && json.resultData.data) || {};
				Object.keys(data).forEach((_key) => {
					const calculateObject = data[_key];
					if (calculateObject && calculateObject.length > 0) {
						const price =
							calculateObject[calculateObject.length - 1]
								.backPayPriceTotal || 0;
						// 比照現金收款：僅加總 > 0 的協議前欠
						if (price > 0) {
							sumAmount += price;
						}
					}
				});
				this.agrBackpayAmount = sumAmount;
			});
		},
		openDialog(item, hasCalculateItem = true) {
			if (!hasCalculateItem) {
				this.calcRepayment(item);
			} else {
				this.iouCalculate = item;
				this.fetchAgrBackpay(
					item.iou && item.iou.id,
					moment(new Date()).format("YYYY/MM/DD")
				);
			}

			setTimeout(() => {
				$(".min_go_date").datepicker({
					changeYear: true,
					changeMonth: true,
					currentText: "今天",
					dateFormat: "Rmmdd",
					showButtonPanel: true,
					yearRange: "1912:c+10",
				});
			}, 1);

			this.dialogListForm = true;
		},
		changeData() {
			let date =
				parseInt($(`.baseDate`).val().split("-")[0]) +
				1911 +
				$(`.baseDate`).val().slice(3);

			this.fetchAgrBackpay(
				this.iouCalculate.iou && this.iouCalculate.iou.id,
				date
			);
			this.calcRepayment(this.iouCalculate.iou.iouNumber, date);
		},
	},
};
</script>
<style lang="scss" scoped>
.fs15 {
	font-size: 15px;
}

.col-block {
	vertical-align: top;
}

.row-set {
	justify-content: space-between;
}

.col-block {
	.block-content {
		padding: 0;
		margin: 15px 20px;
	}
}

.block-content {
	button {
		margin-left: 0;
		margin-bottom: 10px;
		width: 100%;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.box-card {
		margin-bottom: 10px;

		p {
			margin-bottom: 0;
		}

		span {
			font-weight: bold;
		}

		&:last-child {
			margin-bottom: 0;
		}
	}
}

.table {
	td {
		vertical-align: middle;
		padding-top: 8px;
		padding-bottom: 8px;

		&:first-child {
			text-align: right;
		}
	}
}

.btn-set {
	max-width: 100px;
}

.group-member {
	font-size: 20px;
}

.p-re {
	position: relative;
	padding: 15px 0px;

	.btn-set {
		position: relative;
		right: 0;
	}
}

.el-button {
	white-space: normal !important;
}
</style>